define('AwaLabs.Inspectlet', [
    'Tracker',
    'AwaLabs.Inspectlet.Configuration',
    'AwaLabs.Inspectlet.Tracker',
    'AwaLabs.Inspectlet.InstallScript'
], function AwaLabsInspectlet(
    Tracker,
    InspectletConfiguration,
    InspectletTracker,
    InspectletInstallScript
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            /** @type EnvironmentComponent */
            var environment = container.getComponent('Environment');
            InspectletConfiguration.initialize(container);

            if (
                !environment.isPageGenerator()
                && InspectletConfiguration.isEnabled()
                && InspectletConfiguration.isAllowedDomain()
            ) {
                Tracker.getInstance().trackers.push(InspectletTracker);
                InspectletInstallScript.install(container.getLayout());
            }
        }
    };
});
